export default __webpack_public_path__ + "img/2348cfc65e0c2b6f312b453e3910451c.svg";